import { Box, Link, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import moment from "moment";

export default function Footer() {
  return (
    <Box pt={30} align="center">
      <Box sx={{ display: "flex", gap: "20px", alignItems: "center", justifyContent: "center" }}>
        <Link
          component={"a"}
          href="https://bakestreet.co/terms-of-service"
          target="_blank"
          underline="none"
          sx={{ color: "inherit" }}
        >
          Terms of Use
        </Link>
        <Link
          component={"a"}
          href="https://bakestreet.co/privacy-policy"
          target="_blank"
          underline="none"
          sx={{ color: "inherit" }}
        >
          Privacy Policy
        </Link>
      </Box>
      <Typography color="textSecondary" variant="caption">
        &copy; Copyright {moment().format("YYYY")} BakeStreet Inc.
      </Typography>
    </Box>
  );
}
